import { IResult } from '../../../../../../httpClient/serverApi/types/IResponse';
import { TagRequest } from '../../../TagRequest';

import { IAnalyticsExtSiteSettings } from '../../../../../../settings/types/ISiteSettingsForSiteAdmin';

export type IGetAnalyticsExtSiteSettingsResult = IResult & IAnalyticsExtSiteSettings;

export class GetAnalyticsExtSiteSettingsRequest extends TagRequest<{}, IGetAnalyticsExtSiteSettingsResult> {
  constructor() {
    super('analyticsextensions', 'getAnalyticsExtensionsSiteSettings', {});
  }
}
